"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\ttransform: ", ";\n\ttransform-origin: center center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Icon = (0, _styledComponents.default)(function (_ref) {
  var isOpen = _ref.isOpen,
      props = _objectWithoutPropertiesLoose(_ref, ["isOpen"]);

  return _react.default.createElement(_reactIconBase.default, props);
})(_templateObject(), function (props) {
  return props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
});
Icon.displayName = 'Icon';

var DropdownIcon = function DropdownIcon(_ref2) {
  var isOpen = _ref2.isOpen,
      size = _ref2.size,
      props = _objectWithoutPropertiesLoose(_ref2, ["isOpen", "size"]);

  return _react.default.createElement(Icon, _extends({
    isOpen: isOpen
  }, props, {
    size: size,
    viewBox: "0 0 10 6"
  }), _react.default.createElement("path", {
    d: "M0 0h10L5 6"
  }));
};

DropdownIcon.displayName = 'DropdownIcon';
DropdownIcon.propTypes = {
  color: _propTypes.string,
  size: _propTypes.number,
  isOpen: _propTypes.bool
};
DropdownIcon.defaultProps = {
  color: 'currentColor',
  size: 40,
  isOpen: false
};
var _default = DropdownIcon;
exports.default = _default;